import type { z } from 'zod'
import type { NoContext } from '~/services/api/contracts/NoContext'
import { MenuCategoryIndexQuerySchema } from '~/services/api/generated'

// Mirrors MenuCategoryListRequest rules.
export const MenuCategoryIndex = (
  _context: NoContext
): z.ZodType<z.output<typeof MenuCategoryIndexQuerySchema>> => MenuCategoryIndexQuerySchema
